import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group mb-2 mb-sm-2 mb-md-2" }
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_22 = { class: "dropdown text-end" }
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "fa fa-print me-2"
}
const _hoisted_30 = {
  key: 1,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_33 = { class: "modal-dialog" }
const _hoisted_34 = { class: "modal-content p-4" }
const _hoisted_35 = { class: "modal-header border-0" }
const _hoisted_36 = { class: "modal-body" }
const _hoisted_37 = { class: "modal-footer border-0" }
const _hoisted_38 = {
  key: 1,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher une facture"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createVNode(_component_Form, {
      ref: "etatForm",
      "validation-schema": _ctx.etatFacture,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Début ", -1)),
              _createVNode(_component_Field, {
                name: "dateDebut",
                type: "date",
                modelValue: _ctx.dateDebut,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateDebut) = $event)),
                style: {"background-color":"#fff"},
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Choisisser la date"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateDebut",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Fin ", -1)),
              _createVNode(_component_Field, {
                name: "dateFin",
                modelValue: _ctx.dateFin,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateFin) = $event)),
                type: "date",
                style: {"background-color":"#fff"},
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Choisisser la date"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                _createTextVNode(" Type Facture "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "typeFacture",
                modelValue: _ctx.typeFacture,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.typeFacture) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, {
                    options: _ctx.typeFactureOptions,
                    searchable: true,
                    modelValue: _ctx.typeFacture,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.typeFacture) = $event)),
                    placeholder: "Sélectionner",
                    "value-prop": "value",
                    label: "label"
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_component_ErrorMessage, {
              name: "typeFacture",
              class: "text-danger"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Ref Facture "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type de Facture "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date Transformation "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factures, (facture, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(facture.refFac), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", {
                  'bg-light  ': facture.typeFacture === 'Facture proforma',
                  'bg-success': facture.typeFacture === 'Facture de vente',
                  'bg-info': facture.typeFacture === 'Facture de vente à l\'exportation',
                  'bg-warning': facture.typeFacture === 'Facture d\'avoir'

                }])
                  }, _toDisplayString(facture.typeFacture), 3)
                ]),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.format_date(facture.dateFac)), 1),
                _createElementVNode("td", _hoisted_17, [
                  (facture.estTransformee && facture.dateTransformation)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.format_date(facture.dateTransformation)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                ]),
                _createElementVNode("td", _hoisted_20, _toDisplayString(facture?.commande?.client?.nomClient + ' ' + facture?.commande?.client?.prenomClient), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[19] || (_cache[19] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_23, [
                      (facture.typeFacture !== 'Facture proforma' && !facture.estNormalisee)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.normaliser(facture))
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "fa fa-check-circle me-2" }, null, -1),
                              _createTextVNode("Normaliser ")
                            ]), 8, _hoisted_25)
                          ]))
                        : _createCommentVNode("", true),
                      (facture.typeFacture === 'Facture proforma')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.transformerEnCommande(facture))
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "fa fa-exchange me-2" }, null, -1),
                              _createTextVNode("Transformer en commande ")
                            ]), 8, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["dropdown-item d-flex align-items-center", { 'disabled': _ctx.isGeneratingPdf }]),
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.openImpressionModal(facture))
                        }, [
                          (!_ctx.isGeneratingPdf)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                            : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                          _createTextVNode(" " + _toDisplayString(_ctx.isGeneratingPdf ? 'Génération...' : 'Imprimer'), 1)
                        ], 10, _hoisted_28)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(facture.id, _ctx.factures, 'factures', 'la facture'))
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Supprimer ")
                        ]), 8, _hoisted_31)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal fade", { show: _ctx.showModal }]),
          style: {"display":"block"}
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "modal-title" }, "Impression de la facture", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[22] || (_cache[22] = _createElementVNode("p", null, "Choisissez le format de la facture :", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.formatOptions,
                  modelValue: _ctx.selectedFormat,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedFormat) = $event)),
                  placeholder: "Choisir un format",
                  "no-results-text": "Aucun format trouvé"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, "Annuler"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.confirmImpression && _ctx.confirmImpression(...args)))
                }, "Imprimer")
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38))
      : _createCommentVNode("", true)
  ]))
}